// Lista de códigos de país (ITU). Mais usados primeiro; os demais em ordem alfabética.
const RAW = [
  // Mais usados
  ["+1", "US"], ["+55", "BR"], ["+52", "MX"], ["+506", "CR"], ["+503", "SV"], ["+502", "GT"],
  ["+504", "HN"], ["+505", "NI"], ["+507", "PA"], ["+57", "CO"], ["+58", "VE"], ["+51", "PE"],
  ["+593", "EC"], ["+591", "BO"], ["+56", "CL"], ["+54", "AR"], ["+595", "PY"], ["+598", "UY"],
  ["+53", "CU"], ["+509", "HT"], ["+1809", "DO"], ["+1876", "JM"], ["+1787", "PR"],
  ["+351", "PT"], ["+34", "ES"], ["+244", "AO"], ["+238", "CV"], ["+245", "GW"], ["+258", "MZ"],
  // Demais
  ["+93", "AF"], ["+355", "AL"], ["+49", "DE"], ["+376", "AD"], ["+966", "SA"], ["+213", "DZ"],
  ["+374", "AM"], ["+297", "AW"], ["+61", "AU"], ["+43", "AT"], ["+994", "AZ"], ["+1242", "BS"],
  ["+973", "BH"], ["+880", "BD"], ["+1246", "BB"], ["+32", "BE"], ["+501", "BZ"], ["+229", "BJ"],
  ["+375", "BY"], ["+387", "BA"], ["+267", "BW"], ["+673", "BN"], ["+359", "BG"], ["+226", "BF"],
  ["+257", "BI"], ["+975", "BT"], ["+855", "KH"], ["+237", "CM"], ["+974", "QA"],
  ["+235", "TD"], ["+86", "CN"], ["+357", "CY"], ["+269", "KM"], ["+242", "CG"], ["+243", "CD"],
  ["+850", "KP"], ["+82", "KR"], ["+225", "CI"], ["+385", "HR"], ["+45", "DK"], ["+253", "DJ"],
  ["+1767", "DM"], ["+20", "EG"], ["+971", "AE"], ["+291", "ER"], ["+421", "SK"], ["+386", "SI"],
  ["+372", "EE"], ["+268", "SZ"], ["+251", "ET"], ["+679", "FJ"], ["+63", "PH"], ["+358", "FI"],
  ["+33", "FR"], ["+241", "GA"], ["+220", "GM"], ["+233", "GH"], ["+995", "GE"], ["+30", "GR"],
  ["+1473", "GD"], ["+224", "GN"], ["+240", "GQ"], ["+592", "GY"], ["+31", "NL"], ["+852", "HK"],
  ["+36", "HU"], ["+967", "YE"], ["+91", "IN"], ["+62", "ID"], ["+98", "IR"], ["+964", "IQ"],
  ["+353", "IE"], ["+354", "IS"], ["+972", "IL"], ["+39", "IT"], ["+81", "JP"], ["+962", "JO"],
  ["+383", "XK"], ["+965", "KW"], ["+856", "LA"], ["+266", "LS"], ["+371", "LV"], ["+961", "LB"],
  ["+231", "LR"], ["+218", "LY"], ["+423", "LI"], ["+370", "LT"], ["+352", "LU"], ["+853", "MO"],
  ["+389", "MK"], ["+261", "MG"], ["+60", "MY"], ["+265", "MW"], ["+960", "MV"], ["+223", "ML"],
  ["+356", "MT"], ["+212", "MA"], ["+230", "MU"], ["+222", "MR"], ["+373", "MD"], ["+377", "MC"],
  ["+976", "MN"], ["+382", "ME"], ["+95", "MM"], ["+264", "NA"], ["+977", "NP"], ["+227", "NE"],
  ["+234", "NG"], ["+47", "NO"], ["+64", "NZ"], ["+968", "OM"], ["+92", "PK"], ["+970", "PS"],
  ["+675", "PG"], ["+48", "PL"], ["+254", "KE"], ["+44", "GB"], ["+236", "CF"], ["+420", "CZ"],
  ["+40", "RO"], ["+250", "RW"], ["+7", "RU"], ["+685", "WS"], ["+1758", "LC"], ["+1869", "KN"],
  ["+378", "SM"], ["+239", "ST"], ["+1784", "VC"], ["+221", "SN"], ["+232", "SL"], ["+381", "RS"],
  ["+65", "SG"], ["+963", "SY"], ["+252", "SO"], ["+94", "LK"], ["+249", "SD"], ["+211", "SS"],
  ["+46", "SE"], ["+41", "CH"], ["+597", "SR"], ["+66", "TH"], ["+886", "TW"], ["+992", "TJ"],
  ["+255", "TZ"], ["+670", "TL"], ["+228", "TG"], ["+676", "TO"], ["+1868", "TT"], ["+216", "TN"],
  ["+993", "TM"], ["+90", "TR"], ["+380", "UA"], ["+256", "UG"], ["+998", "UZ"], ["+678", "VU"],
  ["+84", "VN"], ["+260", "ZM"], ["+263", "ZW"], ["+27", "ZA"],
];

const seen = new Set();
let regionNames = null;
try { regionNames = new Intl.DisplayNames(["pt-BR"], { type: "region" }); } catch { /* sem suporte */ }
const toFlag = (iso) =>
  iso.length === 2 ? String.fromCodePoint(...[...iso.toUpperCase()].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)) : "🏳️";
const countryName = (iso) => {
  try { return regionNames?.of(iso) || iso; } catch { return iso; }
};

export const COUNTRY_CODES = RAW.filter(([v]) => (seen.has(v) ? false : seen.add(v))).map(
  ([value, iso]) => ({ value, iso, name: countryName(iso), flag: toFlag(iso), label: `${value} (${iso})` })
);

/** Detecta o código de país pelo prefixo mais longo de um número em formato +E.164. */
export function detectCountryCode(phone) {
  if (!phone || !String(phone).trim().startsWith("+")) return null;
  const digits = "+" + String(phone).replace(/\D/g, "");
  let best = null;
  for (const c of COUNTRY_CODES) {
    if (digits.startsWith(c.value) && (!best || c.value.length > best.length)) best = c.value;
  }
  return best;
}
